<template>
    <div class="manageroptions container-fluid p-0">
        <div class="row px-3">
            <add-video-input />
        </div>

        <div class="row px-3 mt-3">
            <div v-if="mobile && selectedVideosLength > 0 || !mobile" :class="['col-12 col-md-4 d-flex justify-content-between justify-content-md-start align-items-center', mobile && 'py-3 py-md-0']">
                <div class="mr-3">
                    <b-form-checkbox
                        id="selectedVideos"
                        name="selectedVideos"
                        v-model="checkSelectedVideos"
                        @change="selectedVideosLength === 0 ? $emit('selectAllVideos') : $emit('removeVideoSelection')"
                    >
                        <span v-if="selectedVideosLength === 1">
                            {{ selectedVideosLength }} mídia selecionada
                        </span>

                        <span v-else-if="selectedVideosLength > 1">
                            {{ selectedVideosLength }} mídias selecionadas
                        </span>

                        <span v-else>
                            Nenhuma mídia selecionada
                        </span>
                    </b-form-checkbox>
                </div>

                <button
                    v-if="selectedVideosLength >= 1"
                    class="btn-delete ml-md-3"
                    @click="$emit('deleteVideosSelected')"
                >
                    <i class="fal fa-trash-alt font-14" aria-hidden="true"></i>
                    <span class="font-sans fw-regular">Excluir</span>
                </button>
            </div>

            <div
                v-if="mobile && selectedVideosLength === 0 || !mobile"
                :class="['col-12 col-md-4 d-flex p-0 justify-content-between justify-content-md-end align-items-center', mobile && 'mx-2']"
            >
                <!-- TIPO DE LISTAGEM -->
                <b-dropdown right class="" size="lg"  variant="link" toggle-class="text-decoration-none">
                    <template #button-content>
                        <i :class="iconDisplayActive" class="icon-display font-14" aria-hidden="true"></i>
                    </template>
                    <b-dropdown-item-button
                        class="text-right"
                        button-class="d-flex justify-content-between"
                        v-for="item in display"
                        :key="item.id"
                        @click="setActiveDisplay(item.id)"
                        :active="isDisplayActive(item)"
                    >
                        <span v-html="item.name" class="mr-3"></span>
                        <i :class="item.icon" class="icon-display font-20" aria-hidden="true"></i>
                    </b-dropdown-item-button>
                </b-dropdown>

                <!-- FILTROS -->
                <b-dropdown
                    class="mx-3 manageroptions-filter"
                    id="dropdown-buttons"
                    :text="activeFilter.name"
                >
                    <b-dropdown-item-button
                        :class="[filter.id == activeFilter.id && 'active']"
                        v-for="filter in filters"
                        :key="filter.id"
                        @click="setActive(filter.id)"
                        :active="isFilterActive(filter)"
                        style=""
                    >
                        <span v-html="filter.name"></span>
                    </b-dropdown-item-button>
                </b-dropdown>
            </div>

            <!-- PESQUISA -->
            <search-input
                :id="'searchVideos'"
                :name="'searchVideos'"
                :onDebounce="searchVideos"
                @clearInputSearch="handleClearInputSearch"
                @inputValueChanged="searchVideo = $event"
            />
        </div>
    </div>
</template>


<script>
import apiMixins from "@/mixins/apiMixins";

import SearchInput from './SearchInput.vue';
import AddVideoInput from './AddVideoInput.vue';

export default {
    name: 'VideoManagerOptions',
    components: { SearchInput, AddVideoInput },
    props: {
        selectedVideosLength: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            mobile: window.innerWidth < 576,
            checkSelectedVideos: false,
            searchTimeoutVideos: null,
            display: [
                {id: 0, name: 'Grande', value: 'icons', icon: 'fal fa-th-large'},
                {id: 1, name: 'Lista', value: 'list', icon: 'fal fa-bars'},
            ],
            filters: [
                {id: 0, name: 'Mais recentes', value: 'created_at-desc'},
                {id: 1, name: 'Mais antigos', value: 'created_at-asc'},
                {id: 2, name: 'Nome A-Z', value: 'name-asc'},
                {id: 3, name: 'Nome Z-A', value: 'name-desc'}
            ],
            activeFilter: {id: 0, name: 'Mais recentes', value: 'created_at-desc'},
            activeDisplay: {id: 0, name: 'Ícones Grandes', value: 'icons'},
            searchVideo: '',
            iconDisplayActive: null
        }
    },
  	mixins: [apiMixins],
    methods: {
        setActive(id) {
            this.activeFilter = this.filters.find(item => item.id === id);
            this.$emit('changeFilter', this.activeFilter.value);
        },
        setActiveDisplay(id) {
            this.activeDisplay = this.display.find(item => item.id === id);
            this.$emit('changeDisplay', this.activeDisplay.value);
        },
        isDisplayActive(display) {
            if (display.id === this.activeDisplay.id) {
                this.iconDisplayActive = display.icon;
                return true;
            } else {
                return false;
            }
        },
        isFilterActive(filter) {
            if (filter.id === this.activeFilter.id) {
                return true;
            } else {
                return false;
            }
        },
        searchVideos() {
            let token = this.$session.get("jwt");
			let siteId = this.$session.get("siteId");

			this.$store.dispatch("userModule/FILTERS_VIDEOS", [token, siteId, this.searchVideo, this.activeFilter.value]);
        },
        handleClearInputSearch() {
            this.searchVideo = '';

            this.searchVideos();
        }
    },
    watch: {
        searchVideo(value) {
            if (value != '') {
                this.$emit('inSearch', true);
            } else {
                this.$emit('inSearch', false);
            }
        },
        selectedVideosLength(value) {
            if (value > 0) {
                this.checkSelectedVideos = true;
            } else {
                this.checkSelectedVideos = false;
            }
        }
    }
}
</script>

<style scoped>
.btn.dropdown-toggle.btn-link {
    color: #000000!important;
}

input#searchMedia {
    background-color: transparent;
    border-bottom: 2px solid #a9a9a9;
}

.btn-delete {
    color: #a9a9a9;
    border: none;
    background-color: transparent;

}

.btn-delete span, .icon-display {
    font-weight: 700;
    color: #a9a9a9;
}

.configs-images-media-manager, .configs-videos-media-manager {
	background-color: #fff;
	white-space: nowrap;
	overflow-x: auto;
	position: fixed;
	left: 0;
	right: 0;
	top: 50px;
	z-index: 501;
	width: 100%;
	padding-right: 30px;
	padding-bottom: 10px;
}

.btn-clear-search  {
	position: absolute;
	font-size: 15px;
	cursor: pointer;
	z-index: 1;
	right: 70px;
}

.add-video-container {
	display: flex;
	flex-direction: column;
}

.add-video-container .add-video {
	display: flex;
	flex-direction: column
}

.add-video-container .add-video label {
	font-size: 12px;
	margin: 0px !important;
	color: #CCCCCC;
}

.add-video-container .add-video input {
	margin-top: 0.3rem;
	margin-bottom: 0.3rem;
}

.add-video-container .add-video .btn.btn-primary {
	font-size: 10px !important;
	font-weight: 300 !important;
}

.add-video-container span {
	font-size: 14px;
	color: #CCCCCC;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/VideoManagerOptions.vue